import { render, staticRenderFns } from "./socialorgDetails.vue?vue&type=template&id=0df0feaa&scoped=true&"
import script from "./socialorgDetails.vue?vue&type=script&lang=js&"
export * from "./socialorgDetails.vue?vue&type=script&lang=js&"
import style0 from "./socialorgDetails.vue?vue&type=style&index=0&id=0df0feaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0feaa",
  null
  
)

export default component.exports